const translations = {
  uk: {
    // Analytics consent
    consentTitle: "Персоналізовані рекомендації",
    consentBody: "Щоб добирати страви точніше, MealPill запам'ятовує ваші дії в застосунку — які рецепти ви зберігаєте, що готуєте, що додаєте в холодильник. З цього формується ваш смаковий профіль.",
    consentNote: "Ці дані зберігаються у нас і не передаються рекламодавцям.",
    consentToggle: "Персоналізувати рекомендації",
    consentHint: "Можна змінити будь-коли в Налаштуваннях",
    consentContinue: "Продовжити",
    privacyTitle: "Приватність",
    privacyAnalyticsDesc: "Використовувати ваші дії в застосунку для персоналізації рекомендацій",
    tipType_storage: "Зберігання",
    tipType_nutrition: "Харчування",
    tipType_warning: "Увага",
    tipType_reminder: "Нагадування",
    tipType_default: "Порада",
    editRecipe: "Редагувати рецепт",
    loadMore: "Завантажити ще",
    // Auth
    login: "Увійти",
    register: "Реєстрація",
    email: "Електронна пошта",
    password: "Пароль",
    forgotPassword: "Забули пароль?",
    resetYourPassword: "Відновлення паролю",
forgotPasswordDesc: "Введи свій email і ми надішлемо посилання для відновлення паролю.",
sendResetLink: "Надіслати посилання",
backToSignIn: "Назад до входу",
checkYourEmail: "Перевір пошту",
resetLinkSent: "Якщо акаунт існує — ми надіслали посилання для відновлення.",
checkSpam: "Не отримав? Перевір папку Спам.",
    name: "Ім'я",
    noAccount: "Немає акаунту?",
    hasAccount: "Вже є акаунт?",
    emailAlreadyRegistered: "Цей email вже зареєстрований. Схоже, у тебе вже є акаунт.",
    goToLogin: "Увійти з цим email",
    genFailed: "Не вдалося згенерувати план. Сервіс ШІ перевантажений — спробуй за хвилину.",
    recipeSaveFailed: "Не вдалося зберегти рецепт. Перевірте з'єднання і спробуйте ще раз.",
    errInvalidCredentials: "Невірний email або пароль.",
    errPasswordMinLength: "Пароль має містити щонайменше 8 символів.",
    errPasswordLetter: "Пароль має містити хоча б одну літеру.",
    errPasswordDigit: "Пароль має містити хоча б одну цифру або спеціальний символ.",
    errPasswordCommon: "Цей пароль занадто поширений. Оберіть надійніший.",
    errResetLinkInvalid: "Посилання для скидання пароля недійсне або застаріле.",
    errResetLinkExpired: "Термін дії посилання минув. Запросіть нове.",
    tipsEmptyState: "Порад поки немає — згенеруйте кілька планів, і вони з'являться тут.",
    errPasswordsDontMatch: "Паролі не збігаються.",
    errNetwork: "Помилка мережі. Спробуйте ще раз.",
    errRateLimit: "Забагато спроб. Спробуй трохи пізніше",
    errGeneric: "Щось пішло не так",
    resetInvalidTitle: "Недійсне посилання",
    resetInvalidBody: "Посилання відсутнє або пошкоджене. Запросіть нове скидання пароля.",
    resetRequestNew: "Запросити нове посилання",
    resetSetNewTitle: "Встановіть новий пароль",
    resetSetNewDesc: "Оберіть надійний пароль, який ви ще не використовували.",
    resetNewPasswordPh: "Новий пароль (мін. 8 символів)",
    resetConfirmPh: "Підтвердьте новий пароль",
    resetSubmit: "Скинути пароль",
    resetDoneTitle: "Пароль змінено",
    resetDoneBody: "Ваш пароль оновлено.",
    resetRedirecting: "Перенаправляємо на вхід...",
    resetGoToSignIn: "Перейти до входу",
    createAccount: "Створити акаунт",
    welcome: "Ласкаво просимо",
    welcomeBack: "З поверненням",
    authBackHome: "Назад до MealPill",
    logout: "Вийти",
    comingSoon: "Незабаром",
    selectDishForPlan: "Виберіть страву для плану",

    // Intro Carousel
    introSlide1Title: "Розумна Аналітика",
    introSlide1Desc: "Відстежуйте калорії, різноманітність раціону та отримуйте персоналізовані рекомендації на основі ваших звичок.",
    introSlide2Title: "Режими Пріоритету",
    introSlide2Desc: "Обирайте між 'Без відходів' для використання продуктів зі спливаючим терміном або 'Нові смаки' для кулінарних експериментів.",
    introSlide3Title: "Щоденні Поради",
    introSlide3Desc: "Отримуйте корисні підказки щодо харчування, приготування та економії на продуктах кожного дня.",
    introSlide4Title: "Система Вподобань",
    introSlide4Desc: "Зберігайте улюблені рецепти та поради. AI враховуватиме ваші вподобання для кращих рекомендацій.",
    getStarted: "Почати",

    // Onboarding
    onboardingTitle: "Давайте налаштуємо Meal Pill для вас",
    step: "Крок",
    of: "з",
    next: "Далі",
    back: "Назад",
    finish: "Завершити",
    skip: "Пропустити",
    
    // Step 0 - Language
    languageTitle: "Оберіть мову",
    languageSubtitle: "Ви можете змінити її пізніше в налаштуваннях",
    langUk: "Українська",
    langEn: "English",
    langRu: "Русский",

    // Step 1 - Goals (multi-select)
    goalTitle: "Чому ви хочете використовувати цю програму?",
    goalSubtitle: "Виберіть усе, що підходить",
    goal_organized: "Щоб бути краще організованим",
    goal_diet: "Щоб допомогти мені з дієтою",
    goal_lose_weight: "Щоб допомогти мені схуднути",
    goal_gain_weight: "Щоб допомогти мені набрати вагу",
    goal_save_money: "Щоб заощадити на продуктах",
    goal_track_habits: "Щоб стежити за харчовими звичками",
    goal_save_time: "Щоб заощадити час",
    goal_recipe_ideas: "Для ідей рецептів",
    goal_health: "Щоб покращити здоров'я",
    goal_family: "Планувати для великої родини",
    goal_muscle: "Збільшити м'язову масу",
    goal_pregnancy: "Через вагітність",
    goal_other: "Інше",

    // Step 2 - Diet type
    dietTitle: "Який у вас спосіб життя?",
    diet_omnivore: "Всеїдний",
    diet_pesco_pollo: "Песко-полло",
    diet_pesco_pollo_desc: "Риба та птиця, без червоного м'яса",
    diet_pescatarian: "Пескетаріанець",
    diet_pescatarian_desc: "Риба, без м'яса",
    diet_vegetarian: "Вегетаріанська",
    diet_vegan: "Веганський",

    // Step 3 - Meals & People
    mealsTitle: "Яку їжу ви хочете запланувати?",
    mealsSubtitle: "Виберіть усе, що підходить",
    breakfast: "Сніданок",
    lunch: "Обід",
    dinner: "Вечеря",
    snack: "Перекус",
    familyTitle: "Для скількох людей ви готуєте?",
    person: "людина",
    people: "людей",
    moreThan5: "Більше 5",

    // Step 4 - Budget & Calendar
    budgetTitle: "Скільки ви витрачаєте на продукти щомісяця?",
    budgetHint: "Планування може заощадити до 30% на продуктах",
    budgetPlaceholder: "Наприклад, 5000",
    firstDayOfWeek: "Перший день тижня",
    monday: "Понеділок",
    tuesday: "Вівторок",
    wednesday: "Середа",
    thursday: "Четвер",
    friday: "П'ятниця",
    saturday: "Субота",
    sunday: "Неділя",

    // Step 5 - Preferences & Skill
    preferencesTitle: "Дієтичні обмеження",
    vegetarian: "Вегетаріанство",
    vegan: "Веганство",
    glutenFree: "Без глютену",
    lactoseFree: "Без лактози",
    nutFree: "Без горіхів",
    halal: "Халяль",
    cookingSkill: "Рівень кулінарії",
    beginner: "Початківець",
    intermediate: "Середній",
    advanced: "Досвідчений",
    cookingTime: "Час на готування",
    quick: "Швидко (до 20 хв)",
    medium: "Середньо (20-45 хв)",
    long: "Довго (45+ хв)",

    // Step 6 - Favorite Ingredients (expanded)
    favIngredientsTitle: "Ваші улюблені продукти",
    favIngredientsSubtitle: "Оберіть те, що ви часто їсте",
    fav_chicken: "Курка",
    fav_beef: "Яловичина",
    fav_pork: "Свинина",
    fav_fish: "Риба",
    fav_eggs: "Яйця",
    fav_rice: "Рис",
    fav_pasta: "Паста",
    fav_potato: "Картопля",
    fav_tomato: "Помідори",
    fav_cheese: "Сир",
    fav_milk: "Молоко",
    fav_bread: "Хліб",
    fav_avocado: "Авокадо",
    fav_salmon: "Лосось",
    fav_shrimp: "Креветки",
    fav_tofu: "Тофу",
    fav_mushrooms: "Гриби",
    fav_broccoli: "Броколі",
    fav_spinach: "Шпинат",
    fav_beans: "Квасоля",
    fav_lentils: "Сочевиця",
    fav_oats: "Вівсянка",
    fav_yogurt: "Йогурт",
    fav_banana: "Банан",
    fav_honey: "Мед",
    fav_nuts: "Горіхи",

    // Step 7 - Favorite Cuisines
    cuisinesTitle: "Улюблені кухні",
    cuisinesSubtitle: "Які кухні світу вам подобаються?",
    cuisine_ukrainian: "Українська",
    cuisine_italian: "Італійська",
    cuisine_asian: "Азійська",
    cuisine_mexican: "Мексиканська",
    cuisine_mediterranean: "Середземноморська",
    cuisine_french: "Французька",
    cuisine_american: "Американська",
    cuisine_indian: "Індійська",
    cuisine_japanese: "Японська",
    cuisine_chinese: "Китайська",
    cuisine_georgian: "Грузинська",
    cuisine_turkish: "Турецька",

    // Home
    greeting: "Привіт",
    todaysMeals: "Сьогоднішнє меню",
    todaysMenu: "Меню на сьогодні",
    todaysMenuCollapsedHint: "Меню на сьогодні згорнуто — торкніться, щоб розгорнути",
    noPlanForToday: "На сьогодні ще нічого не заплановано",
    planForDay: "Спланувати",
    dailyTips: "Поради дня",
    quickActions: "Швидкі дії",
    planMeals: "Планувати",
    myFridge: "Мій холодильник",
    shoppingList: "Список покупок",
    surpriseMe: "Здивуй мене!",
    open: "Відкрити",
    replace: "Замінити",
    skipMeal: "Пропустити",
    skipped: "Пропущено",
    cooked: "Приготовлено ✓",
    noMealPlanned: "Страва ще не запланована",
    noMealsYet: "Меню ще не згенеровано",
    generatePlan: "Створити план",
    loading: "Завантаження...",
    generating: "Генерація...",
    cookTimeShort: "хв",
    removeDish: "Видалити",
    removed: "видалено",
    undo: "Повернути",
    addDish: "Додати страву",
    addDishSelectType: "Оберіть тип страви",
    addDishChooseMode: "Як додати?",
    addDishCustom: "Додати свою страву",
    addFromFavoritesDesc: "Обрати з улюблених рецептів",
    addFromMyRecipesDesc: "Обрати з ваших власних рецептів",
    aiGeneration: "AI генерація",
    aiGenerationDesc: "AI створить страву за вашими вподобаннями",
    generateDish: "Згенерувати",
    generateDishDesc: "AI створить страву за вашими уподобаннями",
    addCustomDish: "Додати своє",
    addCustomDishDesc: "Введіть назву та опис страви",
    dishTitlePlaceholder: "Назва страви",
    dishDescPlaceholder: "Короткий опис (необов'язково)",
    main_course: "Основна страва",
    side_dish: "Гарнір",
    salad: "Салат",
    appetizer: "Закуска",
    likeTip: "Подобається",
    unlikeTip: "Не подобається",

    // Dynamic greetings (50)
    dynGreeting_0: "Чудового кулінарного дня, {name}!",
    dynGreeting_1: "Морквяний пиріг сумує за тобою, {name}",
    dynGreeting_2: "Смузі сьогодні в хорошому настрої!",
    dynGreeting_3: "Час готувати щось неймовірне, {name}!",
    dynGreeting_4: "Сьогодні ідеальний день для нових смаків!",
    dynGreeting_5: "Хтось казав «піца»? Привіт, {name}!",
    dynGreeting_6: "Твій холодильник чекає на пригоди!",
    dynGreeting_7: "Запах свіжої випічки вже в повітрі, {name}",
    dynGreeting_8: "Навіть макарони раді тебе бачити!",
    dynGreeting_9: "Сьогодні готуємо з натхненням!",
    dynGreeting_10: "Авокадо передає привіт, {name}!",
    dynGreeting_11: "Спеції вже шикуються в чергу!",
    dynGreeting_12: "Який сьогодні настрій? Солодкий чи гострий?",
    dynGreeting_13: "Борщ знову запитує про тебе, {name}",
    dynGreeting_14: "Твоя кухня — твоя суперсила!",
    dynGreeting_15: "Час перетворити продукти на шедевр!",
    dynGreeting_16: "Сніданок — це завжди гарна ідея!",
    dynGreeting_17: "Хороший день починається зі смачної їжі!",
    dynGreeting_18: "Картопля вже розігрілась для тебе!",
    dynGreeting_19: "Готуй з любов'ю, {name}!",
    dynGreeting_20: "Сьогодні ти шеф-кухар!",
    dynGreeting_21: "Навіть сіль щаслива тебе бачити!",
    dynGreeting_22: "Пора створити кулінарний шедевр!",
    dynGreeting_23: "Кухня чекає на своє зірку, {name}!",
    dynGreeting_24: "Давай здивуємо смакові рецептори!",
    dynGreeting_25: "Тарілка вже мріє про щось смачне!",
    dynGreeting_26: "Сьогоднішній день пахне корицею!",
    dynGreeting_27: "Час відкрити нові кулінарні горизонти!",
    dynGreeting_28: "Помідори чекають свого зоряного часу!",
    dynGreeting_29: "Гарний настрій + гарна їжа = ідеальний день!",
    dynGreeting_30: "Сьогодні готуємо з душею, {name}!",
    dynGreeting_31: "Пательня вже розігріта, шеф!",
    dynGreeting_32: "Овочі влаштовують вечірку на твоїй тарілці!",
    dynGreeting_33: "Рис передає теплий привіт!",
    dynGreeting_34: "Час додати трохи магії на кухні!",
    dynGreeting_35: "Духовка вже передчуває щось смачне!",
    dynGreeting_36: "Яйця готові до будь-яких пригод!",
    dynGreeting_37: "Бон апеті починається тут, {name}!",
    dynGreeting_38: "Сьогодні на кухні буде весело!",
    dynGreeting_39: "Часник каже: давай готувати!",
    dynGreeting_40: "Кулінарна подорож починається, {name}!",
    dynGreeting_41: "Твій обід буде неперевершеним!",
    dynGreeting_42: "Олія вже тріщить від нетерпіння!",
    dynGreeting_43: "Йогурт хоче стати частиною твого дня!",
    dynGreeting_44: "Мед та вівсянка шлють тобі усмішку!",
    dynGreeting_45: "Сир вже розплавився від радощів!",
    dynGreeting_46: "Зелень чекає на свій вихід, {name}!",
    dynGreeting_47: "Ніщо не зрівняється з домашньою їжею!",
    dynGreeting_48: "Каструля повна ідей для тебе!",
    dynGreeting_49: "Вітаю, смакоше! Що готуємо сьогодні?",

    // Fridge
    fridgeTitle: "Мій холодильник",
    pantryTitle: "Комора",
    addItem: "Додати продукт",
    addFridgeItem: "Додати продукт",
    itemName: "Назва продукту",
    category: "Категорія",
    quantity: "Кількість",
    unit: "Одиниця",
    expiryDate: "Термін придатності",
    meat: "М'ясо",
    fish: "Риба",
    dairy: "Молочні",
    vegetables: "Овочі",
    fruits: "Фрукти",
    frozen: "Заморожені",
    dryGoods: "Крупи",
    spices: "Спеції",
    beverages: "Напої",
    other: "Інше",
    emptyFridge: "Холодильник порожній",
    addFirst: "Додайте перші продукти",
    fridgeSelect: "Вибрати",
    fridgeClear: "Очистити",
    fridgeSelectAll: "Вибрати всі",
    fridgeDeselectAll: "Зняти всі",
    fridgeSelectedCount: "Вибрано: {n}",
    fridgeDeleteSelected: "Видалити вибрані ({n})",
    fridgeClearTitle: "Очистити холодильник?",
    fridgeClearMsg: "Усі продукти ({n}) буде видалено. Повернути їх буде неможливо.",
    fridgeClearConfirm: "Так, очистити",
    save: "Зберегти",
    cancel: "Скасувати",
    delete: "Видалити",
    qs_title: "Що вже є вдома?",
    qs_subtitle: "Торкніться продуктів, які у вас є. Решту додасте потім.",
    qs_skip: "Поки порожньо",
    qs_generate: "Додати в холодильник",
    deleteRecipeTitle: "Видалити рецепт?",
    actionCannotUndo: "Цю дію не можна скасувати",
    nameField: "Назва",
    recipeNamePlaceholder: "Наприклад: Паста карбонара",
    description: "Опис",
    optional: "Необов'язково",
    mealType: "Тип прийому",
    notSpecified: "Не вказувати",
    cookTimeMinLabel: "Час (хв)",
    addIngredient: "Додати інгредієнт",
    cookingSteps: "Кроки приготування",
    describeStep: "Опишіть крок",
    addStepPhoto: "Додати фото до кроку",
    addStep: "Додати крок",
    recipeVideo: "Відео рецепту",
    videoUrlPlaceholder: "Посилання на YouTube або інше відео",
    expiresIn: "Спливає через",
    days: "дн.",
    expired: "Прострочено",
    daysLeft: "дн.",
    today: "Сьогодні",
    fridgeItemCount: "продуктів",
    fridgeItemCount_one: "продукт",
    fridgeItemCount_few: "продукти",
    noExpiringItems: "Немає продуктів, що псуються",
    showAll: "Показати все",
    showingExpiring: "Показано продукти з терміном < 4 дні",
    expiryAlertTitle: "Увага! Термін придатності деяких продуктів спливає менше ніж за 4 дні.",
    expiryAlertMsg: "Переглянути список",
    expiredNotUsed: "Деякі продукти вже прострочені — вони не потрапляють у план",
    newProducts: "Нові продукти",
    newProductsMsg: "{n} продуктів очікують розподілення",
    newProductsMsg_one: "{n} продукт очікує розподілення",
    newProductsMsg_few: "{n} продукти очікують розподілення",
    offCatalogPurgedHint: "{n} продуктів ще не в базі — додамо",
    offCatalogPurgedHint_one: "{n} продукт ще не в базі — додамо, і він зʼявиться",
    offCatalogPurgedHint_few: "{n} продукти ще не в базі — додамо",
    setPendingExpiry: "Вкажіть термін придатності для кожного продукту",
    addToFridge: "Додати в холодильник",
    autoExpiryPremium: "Терміни заповнено автоматично на основі бази продуктів",
    purchased: "Куплено",
    smartCheck: "Розумна перевірка",

    // Meal Planner
    mealPlannerTitle: "Планувальник меню",
    thisWeek: "Цей тиждень",
    generateForDay: "На день",
    generateFor3Days: "На 3 дні",
    generateForWeek: "На тиждень",
    cal: "ккал",
    min: "хв",
    cookTimeLabel: "Час готування",
    cookTimeNoLimit: "Без обмежень",

    // Recipe
    recipeDetails: "Деталі рецепта",
    ingredients: "Інгредієнти",
    instructions: "Інструкція",
    prepTime: "Підготовка",
    cookTime: "Готування",
    servings: "Порцій",
    nutrition: "Поживна цінність",
    protein: "Білки",
    carbs: "Вуглеводи",
    fat: "Жири",
    nutritionPartial: "розраховано за {resolved} з {total} інгредієнтів",
    calories: "Калорії",
    addToFavorites: "Додати до улюблених",
    removeFromFavorites: "Видалити з улюблених",

    // Grocery
    groceryTitle: "Список покупок",
    generateList: "Згенерувати список",
    emptyList: "Список порожній",
    emptyListTitle: "Ваш список порожній",
    emptyListMessage: "Додайте продукти вручну або згенеруйте список з вашого плану харчування",
    addItemManually: "Додати продукт",
    generateFromPlan: "Згенерувати з плану",
    goToPlanner: "Перейти до планувальника",
    or: "або",
    clearAll: "Очистити",
    clearListTitle: "Очистити список?",
    clearListMessage: "Всі продукти будуть видалені з кошика. Цю дію неможливо скасувати.",
    itemsChecked: "відмічено",
    groceryStaleTitle: "Меню було змінено",
    groceryStaleMsg: "Оновіть список покупок для актуальних інгредієнтів",
    refresh: "Оновити",
    translating: "Перекладаємо...",
    syncBannerTitle: "Зміни в рецептах або кількості гостей!",
    syncBannerMsg: "Оновіть список покупок для актуалізації даних",
    updateList: "Оновити",
    generate1Day: "Згенерувати на 1 день",
    generate3Day: "Згенерувати на 3 дні",
    generate7Day: "Згенерувати на 1 тиждень",
    gen1Short: "1 день",
    gen3Short: "3 дні",
    gen7Short: "Тиждень",
    regenerateFor: "Перегенерувати для",
    addItemTitle: "Додати продукт",
    newIngredientThanks: "новий інгредієнт, дякую",
    addToCart: "Додати до покупок",
    stagingEmpty: "Почни вводити продукт…",
    searchOrType: "Пошук або введіть назву",
    allCategories: "Всі категорії",
    noSuggestions: "Почніть вводити назву",
    manualTag: "додано вручну",
    manualItemsSection: "Додано вручну",
    amountPlaceholder: "Кількість",
    qtyDefaultHint: "Перевір кількість і виправ за потреби",
    // Categories matching products.json
    cat_eggs: "Яйця",
    cat_dairy_eggs: "Молочні продукти",
    cat_deli_meat: "Ковбаси",
    cat_mushrooms: "Гриби",
    cat_fruits_berries: "Фрукти та ягоди",
    cat_grains_bakery: "Крупи та хліб",
    cat_nuts_seeds: "Горіхи та насіння",
    cat_spices_oils: "Спеції та олії",
    cat_sweets_snacks: "Солодощі",
    cat_frozen_foods: "Заморозка",
    cat_beverages: "Напої",
    cat_beverages_alcohol: "Алкоголь",
    cat_other: "Інше",
    // Legacy categories (for backwards compatibility)
    cat_spices: "Спеції",
    cat_bakery: "Випічка",

    // Favorites / My Dishes - REFACTORED
    favoritesTitle: "Улюблені",
    myDishesTitle: "Мої страви",
    favorites: "вибране",
    createRecipe: "Створити рецепт",
    saveRecipe: "Зберегти рецепт",
    favoriteRecipes: "Улюблені рецепти",
    myRecipes: "Мої рецепти",
    favoriteTips: "Улюблені поради",
    noDishes: "Поки немає страв",
    noFavoriteRecipes: "Немає улюблених рецептів",
    noMyRecipes: "Немає власних рецептів",
    noFavoriteTips: "Немає улюблених порад",
    addRecipe: "Додати рецепт",

    // Insights
    insightsTitle: "Розумна аналітика",
    weeklySummary: "Тижневий підсумок",
    avgCalories: "Сер. калорії",
    topIngredients: "Топ інгредієнти",
    varietyScore: "Різноманітність",
    wasteRisk: "Ризик псування",
    refreshInsights: "Оновити аналітику",

    // Settings
    settingsTitle: "Налаштування",
    profile: "Профіль",
    language: "Мова",
    preferences: "Уподобання",
    guestMode: "Гостьовий режим",
    guestModeDesc: "Тимчасово збільшити порції для гостей",
    guests: "гостей",
    dateFrom: "Дата від",
    dateTo: "Дата до",
    mealsForGuests: "Прийоми їжі для гостей",
    appVersion: "Версія додатку",
    editPreferences: "Змінити уподобання",
    redoOnboarding: "Пройти налаштування заново",

    // Nav
    home: "Головна",
    fridge: "Холодильник",
    planner: "Планер",
    grocery: "Покупки",
    dishes: "Страви",
    settings: "Налаштування",

    // Side menu
    familyAccess: "Сімейний доступ",
    smartInsights: "Розумна аналітика",
    nutritionMode: "Нутриціологія",
    subscription: "Підписка",
    subTitle: "Meal Pill Підписка",
    subSubtitle: "Переведи планування їжі в чіловий режим",
    subPrice: "CA$8.99/міс",
    subTrialNote: "7 днів безкоштовно, потім CA$8.99/міс",
    subCta: "Спробувати 7 днів безкоштовно",
    subLoading: "Зачекайте...",
    subActiveMsg: "Ваша підписка активна",
    subFinePrint: "Скасувати можна будь-коли. Нагадаємо перед списанням.",
    subBenefit1: "AI-плани харчування на кожен день",
    subBenefit2: "Заміна, додавання і генерація страв з холодильника",
    subBenefit3: "Розумні інсайти і поради",
    subBenefit4: "Функція «Здивуй мене»",
    subBenefit5: "Пріоритизація і виключення продуктів",
    subBenefit6: "Три режими фокусу генерації страв",
    subBenefit7: "Автозаповнення термінів придатності",
    subTrialPrefix: "7 днів безкоштовно, потім",
    subCtaSubscribe: "Оформити підписку",
    subTrialEndedTitle: "Пробний період завершено",
    subTrialEndedBody: "Продовжте, щоб і далі планувати меню та бачити вартість тижня.",
    subAutoRenew: "Підписка поновлюється автоматично. Скасувати можна будь-коли одним кліком.",
    subFirstChargeTrial: "Перше списання — {date}",
    subFirstChargeNow: "Списання одразу після оформлення, далі — за обраним планом.",
    subTermsLink: "Умови підписки",
    "billing.success.checking": "Підтверджуємо оплату…",
    "billing.success.title": "Підписку активовано 🎉",
    "billing.success.subtitle": "Дякуємо! Тепер усі функції відкриті.",
    "billing.success.cta": "До застосунку",
    "billing.success.pending": "Оплату отримано. Статус оновлюється — це може зайняти до хвилини.",
    "billing.success.refresh": "Оновити",
    "billing.cancel.title": "Оплату скасовано",
    "billing.cancel.subtitle": "Підписку не оформлено. Можеш повернутись і спробувати ще раз.",
    "billing.cancel.back": "Повернутись до планів",
    "billing.cancel.home": "На головну",
    "planDaysLeft_one":  "Залишилось: {n} день планування",
    "planDaysLeft_few":  "Залишилось: {n} дні планування",
    "planDaysLeft_many": "Залишилось: {n} днів планування",
    "planDaysExhausted": "Ви використали всі дні для планування.",
    "planDaysInsufficient": "Недостатньо днів на {n}-денний план. Спробуй план на меншу кількість днів.",
    "subManage": "Керування підпискою",
    "subNextBilling": "Наступне списання:",
    "subTrialUntil": "Пробний період до:",
    "subCanceledUntil": "Підписку скасовано. Доступ до:",
    "subPortalError": "Не вдалося відкрити керування. Спробуйте пізніше.",
    subPlanYear: "Рік",
    subPlanMonth: "Місяць",
    subPriceYear: "CA$89.99/рік",
    subPriceMonth: "CA$8.99/міс",
    subBestValue: "Найвигідніше",
    subSaveNote: "Заощаджуєте 2 місяці",
    subTrialShort: "7 днів безкоштовно",
    faq: "FAQ",
    privacy: "Конфіденційність",
    terms: "Умови використання",
    termsAgreePrefix: "Я приймаю",
    termsLinkLabel: "Умови використання",
    termsAgreeAnd: "та",
    privacyLinkLabel: "Політику конфіденційності",
    support: "Підтримка",

    // Skip meal
    skipMealTitle: "Пропустити прийом їжі",
    skipReason: "Коментар (необов'язково)",
    skipReasonPlaceholder: "Наприклад: їв щось інше...",
    confirmSkip: "Пропустити",
    ateElsewhere: "Їв інше",
    notHungry: "Не голодний",

    // Servings / Guest scaling
    servingsFor: "на",
    persons: "осіб",
    scaledIngredients: "Інгредієнти масштабовано",

    // Ingredient context
    inFridge: "Є в холодильнику",
    inCart: "Вже в плані покупок",
    missing: "Немає",
    addMissingToCart: "Додати відсутні в кошик",
    addedToCart: "Додано в кошик!",
    cart: "Кошик",
    likedTips: "Вподобані поради",
    viewAll: "Дивитись все",
    
    // Add to Plan modal
    addToPlan: "Додати до плану",
    selectDate: "На який день?",
    selectMealType: "Який прийом їжі?",
    
    // Tips page
    allTips: "Всі",
    nutritionTips: "Харчування",
    storageTips: "Зберігання",
    warningTips: "Попередження",
    noLikedTips: "Немає вподобаних порад",
    noTipsAvailable: "Немає порад",
    tipsAvailable: "порад",
    tipsForYou: "Поради для вас",
    ingredientsTipHint: "Натисни на інгредієнт щоб дізнатись більше",
    selectIngredientHint: "Обери інгредієнт щоб побачити деталі",
    noInfoAvailable: "Інформація недоступна",
    storageSection: "Поради зі зберігання",
    vitamins: "Вітаміни",
    benefits: "Користь",
    storageTip: "Зберігання",
    kcal: "ккал",

    // Dynamic servings scaling
    unsavedServingsChanges: "Натисніть 'Зберегти' для перерахунку",
    servingsIncreased: "Кількість гостей збільшена.",
    addDeficitToCart: "Додати різницю в план покупок?",
    addToCart: "Додати",
    needMore: "Потрібно ще",

    // Temporary exclusions
    temporaryExclusions: "Тимчасові виключення",
    temporaryExclusionsDesc: "AI не буде пропонувати рецепти з цими інгредієнтами",
    addExclusion: "Додати виключення",
    exclusionIngredient: "Інгредієнт",
    excludeUntil: "Виключити до",
    oneWeek: "1 тиждень",
    twoWeeks: "2 тижні",
    oneMonth: "1 місяць",
    noExclusions: "Немає активних виключень",
    priorityIngredients: "Пріоритетні продукти",
    priorityIngredientsDesc: "AI намагатиметься включати ці продукти в кожен день (м'який пріоритет, до 10)",
    addPriority: "Додати продукт",
    priorityIngredient: "Пошук продукту…",
    noPriority: "Поки що немає пріоритетних продуктів",
    priorityLimitReached: "Максимум 10 продуктів",

    // Focus mode
    focusMode: "Режим фокусу",
    focusModeDesc: "Як AI обирає рецепти",
    focusNoWaste: "Без відходів",
    focusNoWasteDesc: "Пріоритет продуктам з холодильника, що скоро псуються",
    focusNewFlavors: "Нові смаки",
    focusNewFlavorsDesc: "Пріоритет новим інгредієнтам",
    focusBalance: "Баланс",
    focusBalanceDesc: "Мікс обох підходів",

    // Language selection
    selectLanguage: "Оберіть мову",
    continueBtn: "Продовжити",
    languageCanChange: "Ви зможете змінити мову в налаштуваннях",

    // Onboarding favorite products - categories
    selectAllCategory: "Обрати все",
    deselectAll: "Зняти вибір",
    
    // Tutorial
    tutorialSkip: "Пропустити",
    tutorialNext: "Далі",
    tutorialStep1: "Натисни 'Генерувати', щоб створити свій перший план харчування",
    tutorialStep2: "Чудово! Тепер натисни на страву, щоб побачити рецепт",
    tutorialStep3: "Натисни 'Додати відсутні в кошик', щоб додати інгредієнти до списку покупок",
    tutorialStep4: "Тепер перейди в корзину, щоб переглянути інгредієнти",
    tutorialStep5: "Відміть усі продукти, тоді натисни «Куплено»",
    tutorialStep6: "Чудово! Тепер перейди в холодильник, щоб зберегти продукти",
    tutorialStep7: "Давай додамо терміни придатності до нових продуктів",
    tutorialStep8: "Продукти в безпеці! Натисни на головну, щоб подивитись що готуємо сьогодні",
    tutorialStep9: "Давай приготуємо цей омлет! Натисни на страву",
    tutorialStep10: "Ми впорались! Натисни 'Готово', щоб я автоматично прибрав використані продукти з холодильника",
    scrollDown: "Прогорни вниз",
    goToShoppingList: "Перейти в план покупок",
    markAsDone: "Готово",
    unsavedServingsWarning: "Зміни порцій не збережено. Покинути без збереження?",

    // Onboarding favorite ingredients
    fav_turkey: "Індичка", fav_lamb: "Баранина", fav_bacon: "Бекон", fav_sausage: "Ковбаса",
    fav_tuna: "Тунець", fav_cod: "Тріска", fav_mussels: "Мідії",
    fav_butter: "Масло", fav_cream: "Вершки", fav_cottage_cheese: "Сир кисломолочний",
    fav_onion: "Цибуля", fav_garlic: "Часник", fav_carrot: "Морква", fav_pepper: "Перець",
    fav_cucumber: "Огірок", fav_zucchini: "Кабачок", fav_cabbage: "Капуста", fav_eggplant: "Баклажан",
    fav_apple: "Яблуко", fav_orange: "Апельсин", fav_lemon: "Лимон", fav_berries: "Ягоди", fav_grapes: "Виноград",
    fav_buckwheat: "Гречка", fav_quinoa: "Кіноа", fav_flour: "Борошно",
    fav_chickpeas: "Нут", fav_peas: "Горох",
    fav_lavash: "Лаваш", fav_bun: "Булочки", fav_pastry: "Здоба", fav_gluten_free_bread: "Безглютеновий хліб", fav_crackers: "Крекери", fav_pita: "Піта",
    cat_meat: "М'ясо", cat_seafood: "Морепродукти", cat_dairy: "Молочні", cat_vegetables: "Овочі",
    cat_fruits: "Фрукти", cat_grains: "Крупи", cat_legumes: "Бобові",
    noInsightsYet: "Поки немає інсайтів",
    noInsightsDesc: "Готуйте більше страв — AI аналізує ваш раціон і надасть персональні поради",

    mealScoreTitle: "Як вам страва?",
    mealScoreSub: "Ваша оцінка допоможе AI рекомендувати краще",

    // Admin panel
    adminAccessTitle: "Admin доступ",
    adminAccessSub: "Введіть пароль адміна",
    adminPassword: "Пароль",
    adminVerifying: "Перевірка...",
    adminEnter: "Увійти",
    adminWrongPassword: "Невірний пароль",
    adminLogout: "Вийти",
    adminDashboard: "Дашборд",
    adminUsers: "Користувачі",
    adminUnknownProducts: "Невідомі продукти",
    adminSupport: "Підтримка",
    adminStats: "Загальна статистика",
    adminAllRecognized: "Всі продукти розпізнані",
    adminNoMessages: "Повідомлень немає",
    adminNew: "Нові",
    adminAll: "Всі",
    adminRead: "Прочитані",
    adminLoadError: "Помилка завантаження",
    generateFromFridge: "З наявних інгредієнтів",
    fromFridge: "З холодильника",
  },

  en: {
    // Analytics consent
    consentTitle: "Personalized suggestions",
    consentBody: "To suggest meals that fit you better, MealPill remembers what you do in the app — which recipes you save, what you cook, what you add to your fridge. This builds your taste profile.",
    consentNote: "This data stays with us and is never shared with advertisers.",
    consentToggle: "Personalize my suggestions",
    consentHint: "You can change this anytime in Settings",
    consentContinue: "Continue",
    privacyTitle: "Privacy",
    privacyAnalyticsDesc: "Use your in-app actions to personalize suggestions",
    tipType_storage: "Storage",
    tipType_nutrition: "Nutrition",
    tipType_warning: "Warning",
    tipType_reminder: "Reminder",
    tipType_default: "Tip",
    editRecipe: "Edit recipe",
    loadMore: "Load more",
    // Auth
    login: "Log In",
    register: "Sign Up",
    email: "Email",
    password: "Password",
    forgotPassword: "Forgot password?",
    resetYourPassword: "Reset your password",
forgotPasswordDesc: "Enter your email and we'll send you a link to reset your password.",
sendResetLink: "Send reset link",
backToSignIn: "Back to sign in",
checkYourEmail: "Check your email",
resetLinkSent: "If an account exists for that email, we've sent a reset link.",
checkSpam: "Didn't receive it? Check your spam folder.",
    name: "Name",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    emailAlreadyRegistered: "This email is already registered. Looks like you already have an account.",
    goToLogin: "Sign in with this email",
    genFailed: "Couldn't generate the plan. The AI service is busy — please try again in a minute.",
    recipeSaveFailed: "Could not save the recipe. Check your connection and try again.",
    errInvalidCredentials: "Invalid email or password.",
    errPasswordMinLength: "Password must be at least 8 characters.",
    errPasswordLetter: "Password must contain at least one letter.",
    errPasswordDigit: "Password must contain at least one digit or special character.",
    errPasswordCommon: "This password is too common. Please choose a stronger one.",
    errResetLinkInvalid: "Invalid or expired reset link.",
    errResetLinkExpired: "Reset link has expired. Please request a new one.",
    tipsEmptyState: "No tips yet — generate a few meal plans and they'll show up here.",
    errPasswordsDontMatch: "Passwords don't match.",
    errNetwork: "Network error. Please try again.",
    errRateLimit: "Too many attempts. Try again later",
    errGeneric: "Something went wrong",
    resetInvalidTitle: "Invalid reset link",
    resetInvalidBody: "This link is missing or malformed. Please request a new password reset.",
    resetRequestNew: "Request new reset link",
    resetSetNewTitle: "Set new password",
    resetSetNewDesc: "Choose a strong password you haven't used before.",
    resetNewPasswordPh: "New password (min 8 characters)",
    resetConfirmPh: "Confirm new password",
    resetSubmit: "Reset password",
    resetDoneTitle: "Password reset",
    resetDoneBody: "Your password has been updated.",
    resetRedirecting: "Redirecting to sign in...",
    resetGoToSignIn: "Go to sign in",
    createAccount: "Create Account",
    welcome: "Welcome",
    welcomeBack: "Welcome back",
    authBackHome: "Back to MealPill",
    logout: "Log Out",
    comingSoon: "Coming Soon",
    selectDishForPlan: "Select a dish for the plan",

    // Intro Carousel
    introSlide1Title: "Smart Analytics",
    introSlide1Desc: "Track calories, diet variety and get personalized recommendations based on your habits.",
    introSlide2Title: "Priority Modes",
    introSlide2Desc: "Choose between 'No Waste' to use expiring products or 'New Flavors' for culinary experiments.",
    introSlide3Title: "Daily Tips",
    introSlide3Desc: "Get useful tips on nutrition, cooking and saving on groceries every day.",
    introSlide4Title: "Favorites System",
    introSlide4Desc: "Save your favorite recipes and tips. AI will consider your preferences for better recommendations.",
    getStarted: "Get Started",

    // Onboarding
    onboardingTitle: "Let's set up Meal Pill for you",
    step: "Step",
    of: "of",
    next: "Next",
    back: "Back",
    finish: "Finish",
    skip: "Skip",

    // Step 0 - Language
    languageTitle: "Choose your language",
    languageSubtitle: "You can change it later in settings",
    langUk: "Українська",
    langEn: "English",
    langRu: "Русский",

    // Step 1 - Goals
    goalTitle: "Why do you want to use this app?",
    goalSubtitle: "Select all that apply",
    goal_organized: "To be better organized",
    goal_diet: "To help me with my diet",
    goal_lose_weight: "To help me lose weight",
    goal_gain_weight: "To help me gain weight",
    goal_save_money: "To save on groceries",
    goal_track_habits: "To track my eating habits",
    goal_save_time: "To save time",
    goal_recipe_ideas: "For recipe ideas",
    goal_health: "To improve my health",
    goal_family: "To plan for a large family",
    goal_muscle: "To increase muscle mass",
    goal_pregnancy: "Due to pregnancy",
    goal_other: "Other",

    // Step 2 - Diet type
    dietTitle: "What is your lifestyle?",
    diet_omnivore: "Omnivore",
    diet_pesco_pollo: "Pesco-pollo",
    diet_pesco_pollo_desc: "Fish and poultry, no red meat",
    diet_pescatarian: "Pescatarian",
    diet_pescatarian_desc: "Fish, no meat",
    diet_vegetarian: "Vegetarian",
    diet_vegan: "Vegan",

    // Step 3 - Meals & People
    mealsTitle: "Which meals do you want to plan?",
    mealsSubtitle: "Select all that apply",
    breakfast: "Breakfast",
    lunch: "Lunch",
    dinner: "Dinner",
    snack: "Snack",
    familyTitle: "How many people are you cooking for?",
    person: "person",
    people: "people",
    moreThan5: "More than 5",

    // Step 4 - Budget & Calendar
    budgetTitle: "How much do you spend on groceries monthly?",
    budgetHint: "Meal planning can save up to 30% on groceries",
    budgetPlaceholder: "e.g., 500",
    firstDayOfWeek: "First day of week",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",

    // Step 5 - Preferences & Skill
    preferencesTitle: "Dietary restrictions",
    vegetarian: "Vegetarian",
    vegan: "Vegan",
    glutenFree: "Gluten-free",
    lactoseFree: "Lactose-free",
    nutFree: "Nut-free",
    halal: "Halal",
    cookingSkill: "Cooking skill",
    beginner: "Beginner",
    intermediate: "Intermediate",
    advanced: "Advanced",
    cookingTime: "Cooking time preference",
    quick: "Quick (up to 20 min)",
    medium: "Medium (20-45 min)",
    long: "Long (45+ min)",

    // Step 6 - Favorite Ingredients (expanded)
    favIngredientsTitle: "Your favorite ingredients",
    favIngredientsSubtitle: "Select what you eat often",
    fav_chicken: "Chicken",
    fav_beef: "Beef",
    fav_pork: "Pork",
    fav_fish: "Fish",
    fav_eggs: "Eggs",
    fav_rice: "Rice",
    fav_pasta: "Pasta",
    fav_potato: "Potato",
    fav_tomato: "Tomato",
    fav_cheese: "Cheese",
    fav_milk: "Milk",
    fav_bread: "Bread",
    fav_avocado: "Avocado",
    fav_salmon: "Salmon",
    fav_shrimp: "Shrimp",
    fav_tofu: "Tofu",
    fav_mushrooms: "Mushrooms",
    fav_broccoli: "Broccoli",
    fav_spinach: "Spinach",
    fav_beans: "Beans",
    fav_lentils: "Lentils",
    fav_oats: "Oats",
    fav_yogurt: "Yogurt",
    fav_banana: "Banana",
    fav_honey: "Honey",
    fav_nuts: "Nuts",

    // Step 7 - Favorite Cuisines
    cuisinesTitle: "Favorite Cuisines",
    cuisinesSubtitle: "Which world cuisines do you enjoy?",
    cuisine_ukrainian: "Ukrainian",
    cuisine_italian: "Italian",
    cuisine_asian: "Asian",
    cuisine_mexican: "Mexican",
    cuisine_mediterranean: "Mediterranean",
    cuisine_french: "French",
    cuisine_american: "American",
    cuisine_indian: "Indian",
    cuisine_japanese: "Japanese",
    cuisine_chinese: "Chinese",
    cuisine_georgian: "Georgian",
    cuisine_turkish: "Turkish",

    // Home
    greeting: "Hello",
    todaysMeals: "Today's Meals",
    todaysMenu: "Today's Menu",
    todaysMenuCollapsedHint: "Today's menu is collapsed — tap to expand",
    noPlanForToday: "Nothing planned for today yet",
    planForDay: "Plan meals",
    dailyTips: "Daily Tips",
    quickActions: "Quick Actions",
    planMeals: "Plan Meals",
    myFridge: "My Fridge",
    shoppingList: "Shopping List",
    surpriseMe: "Surprise Me!",
    open: "Open",
    replace: "Replace",
    skipMeal: "Skip",
    skipped: "Skipped",
    cooked: "Cooked ✓",
    noMealPlanned: "No meal planned yet",
    noMealsYet: "No meals planned yet",
    generatePlan: "Generate Plan",
    loading: "Loading...",
    generating: "Generating...",
    cookTimeShort: "min",
    removeDish: "Remove",
    removed: "removed",
    undo: "Undo",
    addDish: "Add dish",
    addDishSelectType: "Choose dish type",
    addDishChooseMode: "How to add?",
    addDishCustom: "Add custom dish",
    addFromFavoritesDesc: "Pick from your favorite recipes",
    addFromMyRecipesDesc: "Pick from your own recipes",
    aiGeneration: "AI Generation",
    aiGenerationDesc: "AI will create a dish based on your preferences",
    generateDish: "Generate",
    generateDishDesc: "AI will create a dish based on your preferences",
    addCustomDish: "Add your own",
    addCustomDishDesc: "Enter dish name and description",
    dishTitlePlaceholder: "Dish name",
    dishDescPlaceholder: "Brief description (optional)",
    main_course: "Main course",
    side_dish: "Side dish",
    salad: "Salad",
    appetizer: "Appetizer",
    likeTip: "Like",
    unlikeTip: "Unlike",

    // Dynamic greetings (50)
    dynGreeting_0: "Wonderful culinary day, {name}!",
    dynGreeting_1: "The carrot cake misses you, {name}",
    dynGreeting_2: "The smoothie is in a great mood today!",
    dynGreeting_3: "Time to cook something amazing, {name}!",
    dynGreeting_4: "Today is the perfect day for new flavors!",
    dynGreeting_5: "Someone said pizza? Hello, {name}!",
    dynGreeting_6: "Your fridge is ready for adventures!",
    dynGreeting_7: "Fresh pastry aroma is in the air, {name}",
    dynGreeting_8: "Even the pasta is happy to see you!",
    dynGreeting_9: "Today we cook with inspiration!",
    dynGreeting_10: "The avocado sends its regards, {name}!",
    dynGreeting_11: "Spices are lining up for duty!",
    dynGreeting_12: "What's the vibe today? Sweet or spicy?",
    dynGreeting_13: "The soup keeps asking about you, {name}",
    dynGreeting_14: "Your kitchen is your superpower!",
    dynGreeting_15: "Time to turn ingredients into a masterpiece!",
    dynGreeting_16: "Breakfast is always a great idea!",
    dynGreeting_17: "A good day starts with delicious food!",
    dynGreeting_18: "The potatoes are already warmed up for you!",
    dynGreeting_19: "Cook with love, {name}!",
    dynGreeting_20: "Today you're the chef!",
    dynGreeting_21: "Even the salt is happy to see you!",
    dynGreeting_22: "Time to create a culinary masterpiece!",
    dynGreeting_23: "The kitchen awaits its star, {name}!",
    dynGreeting_24: "Let's surprise those taste buds!",
    dynGreeting_25: "The plate is dreaming of something tasty!",
    dynGreeting_26: "Today smells like cinnamon!",
    dynGreeting_27: "Time to explore new culinary horizons!",
    dynGreeting_28: "Tomatoes are waiting for their moment!",
    dynGreeting_29: "Great mood + great food = perfect day!",
    dynGreeting_30: "Today we cook with soul, {name}!",
    dynGreeting_31: "The pan is already warmed up, chef!",
    dynGreeting_32: "Veggies are throwing a party on your plate!",
    dynGreeting_33: "Rice sends warm greetings!",
    dynGreeting_34: "Time to add some magic to the kitchen!",
    dynGreeting_35: "The oven senses something delicious!",
    dynGreeting_36: "Eggs are ready for any adventure!",
    dynGreeting_37: "Bon appétit starts here, {name}!",
    dynGreeting_38: "Today will be fun in the kitchen!",
    dynGreeting_39: "Garlic says: let's cook!",
    dynGreeting_40: "Culinary journey begins, {name}!",
    dynGreeting_41: "Your lunch will be extraordinary!",
    dynGreeting_42: "The oil is sizzling with anticipation!",
    dynGreeting_43: "Yogurt wants to be part of your day!",
    dynGreeting_44: "Honey and oatmeal are smiling at you!",
    dynGreeting_45: "The cheese melted with joy!",
    dynGreeting_46: "The greens await their entrance, {name}!",
    dynGreeting_47: "Nothing beats homemade food!",
    dynGreeting_48: "The pot is full of ideas for you!",
    dynGreeting_49: "Hello, food lover! What are we cooking?",

    // Fridge
    fridgeTitle: "My Fridge",
    pantryTitle: "Pantry",
    addItem: "Add",
    addFridgeItem: "Add item",
    itemName: "Item name",
    category: "Category",
    quantity: "Quantity",
    unit: "Unit",
    expiryDate: "Expiry date",
    meat: "Meat",
    fish: "Fish",
    dairy: "Dairy",
    vegetables: "Vegetables",
    fruits: "Fruits",
    frozen: "Frozen",
    dryGoods: "Dry Goods",
    spices: "Spices",
    beverages: "Beverages",
    other: "Other",
    emptyFridge: "Fridge is empty",
    addFirst: "Add your first items",
    fridgeSelect: "Select",
    fridgeClear: "Clear",
    fridgeSelectAll: "Select all",
    fridgeDeselectAll: "Deselect all",
    fridgeSelectedCount: "Selected: {n}",
    fridgeDeleteSelected: "Delete selected ({n})",
    fridgeClearTitle: "Clear the fridge?",
    fridgeClearMsg: "All items ({n}) will be removed. This cannot be undone.",
    fridgeClearConfirm: "Yes, clear",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    qs_title: "What's in your kitchen?",
    qs_subtitle: "Tap the items you have. You can add the rest later.",
    qs_skip: "Nothing yet",
    qs_generate: "Add to fridge",
    deleteRecipeTitle: "Delete recipe?",
    actionCannotUndo: "This action cannot be undone",
    nameField: "Name",
    recipeNamePlaceholder: "E.g. Pasta carbonara",
    description: "Description",
    optional: "Optional",
    mealType: "Meal type",
    notSpecified: "Not specified",
    cookTimeMinLabel: "Time (min)",
    addIngredient: "Add ingredient",
    cookingSteps: "Cooking steps",
    describeStep: "Describe step",
    addStepPhoto: "Add step photo",
    addStep: "Add step",
    recipeVideo: "Recipe video",
    videoUrlPlaceholder: "YouTube or other video link",
    expiresIn: "Expires in",
    days: "days",
    expired: "Expired",
    daysLeft: "days",
    today: "Today",
    fridgeItemCount: "items",
    fridgeItemCount_one: "item",
    fridgeItemCount_few: "items",
    noExpiringItems: "No items expiring soon",
    showAll: "Show all",
    showingExpiring: "Showing items expiring in < 4 days",
    expiryAlertTitle: "Warning! Some products expire in less than 4 days.",
    expiryAlertMsg: "View the list",
    expiredNotUsed: "Some products have already expired — they are not used in meal plans",
    newProducts: "New Products",
    newProductsMsg: "{n} items waiting to be sorted",
    newProductsMsg_one: "{n} item waiting to be sorted",
    newProductsMsg_few: "{n} items waiting to be sorted",
    offCatalogPurgedHint: "{n} products aren't in the database yet — we'll add them",
    offCatalogPurgedHint_one: "{n} product isn't in the database yet — we'll add it",
    offCatalogPurgedHint_few: "{n} products aren't in the database yet — we'll add them",
    setPendingExpiry: "Set expiry date for each product",
    addToFridge: "Add to Fridge",
    autoExpiryPremium: "Dates auto-filled from product database",
    purchased: "Purchased",
    smartCheck: "Smart Check",

    // Meal Planner
    mealPlannerTitle: "Meal Planner",
    thisWeek: "This Week",
    generateForDay: "1 Day",
    generateFor3Days: "3 Days",
    generateForWeek: "1 Week",
    cal: "kcal",
    min: "min",
    cookTimeLabel: "Cook time",
    cookTimeNoLimit: "No limit",

    // Recipe
    recipeDetails: "Recipe Details",
    ingredients: "Ingredients",
    instructions: "Instructions",
    prepTime: "Prep Time",
    cookTime: "Cook Time",
    servings: "Servings",
    nutrition: "Nutrition",
    protein: "Protein",
    carbs: "Carbs",
    fat: "Fat",
    nutritionPartial: "calculated from {resolved} of {total} ingredients",
    calories: "Calories",
    addToFavorites: "Add to Favorites",
    removeFromFavorites: "Remove from Favorites",

    // Grocery
    groceryTitle: "Shopping List",
    generateList: "Generate List",
    emptyList: "List is empty",
    emptyListTitle: "Your list is empty",
    emptyListMessage: "Add items manually or generate a list from your meal plan",
    addItemManually: "Add item",
    generateFromPlan: "Generate from plan",
    goToPlanner: "Go to planner",
    or: "or",
    clearAll: "Clear all",
    clearListTitle: "Clear the list?",
    clearListMessage: "All items will be removed from the cart. This action cannot be undone.",
    itemsChecked: "checked",
    groceryStaleTitle: "Meal plan has changed",
    groceryStaleMsg: "Refresh the list for updated ingredients",
    refresh: "Refresh",
    translating: "Translating...",
    syncBannerTitle: "Changes in recipes or guest count!",
    syncBannerMsg: "Update the shopping list to reflect the latest data",
    updateList: "Update",
    generate1Day: "Generate for 1 day",
    generate3Day: "Generate for 3 days",
    generate7Day: "Generate for 1 week",
    gen1Short: "1 day",
    gen3Short: "3 days",
    gen7Short: "Week",
    regenerateFor: "Regenerate for",
    addItemTitle: "Add item",
    newIngredientThanks: "new ingredient, thanks",
    addToCart: "Add to cart",
    stagingEmpty: "Start typing a product…",
    searchOrType: "Search or type name",
    allCategories: "All categories",
    noSuggestions: "Start typing a name",
    manualTag: "added manually",
    manualItemsSection: "Added manually",
    amountPlaceholder: "Quantity",
    qtyDefaultHint: "Check quantity and adjust if needed",
    // Categories matching products.json
    cat_eggs: "Eggs",
    cat_dairy_eggs: "Dairy",
    cat_deli_meat: "Deli Meat",
    cat_mushrooms: "Mushrooms",
    cat_fruits_berries: "Fruits & Berries",
    cat_grains_bakery: "Grains & Bakery",
    cat_nuts_seeds: "Nuts & Seeds",
    cat_spices_oils: "Spices & Oils",
    cat_sweets_snacks: "Sweets & Snacks",
    cat_frozen_foods: "Frozen Foods",
    cat_beverages: "Beverages",
    cat_beverages_alcohol: "Alcohol",
    cat_other: "Other",
    // Legacy
    cat_spices: "Spices",

    // Favorites / My Dishes - REFACTORED
    favoritesTitle: "Favorites",
    myDishesTitle: "My Dishes",
    favorites: "favorites",
    createRecipe: "Create Recipe",
    saveRecipe: "Save Recipe",
    favoriteRecipes: "Favorite Recipes",
    myRecipes: "My Recipes",
    favoriteTips: "Favorite Tips",
    noDishes: "No dishes yet",
    noFavoriteRecipes: "No favorite recipes",
    noMyRecipes: "No custom recipes",
    noFavoriteTips: "No favorite tips",
    addRecipe: "Add Recipe",

    // Insights
    insightsTitle: "Smart Insights",
    weeklySummary: "Weekly Summary",
    avgCalories: "Avg Calories",
    topIngredients: "Top Ingredients",
    varietyScore: "Variety Score",
    wasteRisk: "Waste Risk",
    refreshInsights: "Refresh Insights",

    // Settings
    settingsTitle: "Settings",
    profile: "Profile",
    language: "Language",
    preferences: "Preferences",
    guestMode: "Guest Mode",
    guestModeDesc: "Temporarily increase portions for guests",
    guests: "guests",
    dateFrom: "Date from",
    dateTo: "Date to",
    mealsForGuests: "Meals for guests",
    appVersion: "App Version",
    editPreferences: "Edit Preferences",
    redoOnboarding: "Redo Setup",

    // Nav
    home: "Home",
    fridge: "Fridge",
    planner: "Planner",
    grocery: "Shopping",
    dishes: "Dishes",
    settings: "Settings",

    // Side menu
    familyAccess: "Family Access",
    smartInsights: "Smart Insights",
    nutritionMode: "Nutrition",
    subscription: "Subscription",
    subTitle: "Meal Pill Subscription",
    subSubtitle: "Put your meal planning on chill mode",
    subPrice: "CA$8.99/mo",
    subTrialNote: "7 days free, then CA$8.99/mo",
    subCta: "Start 7-day free trial",
    subLoading: "Please wait...",
    subActiveMsg: "Your subscription is active",
    subFinePrint: "Cancel anytime. We'll remind you before you're charged.",
    subBenefit1: "AI meal plans for every day",
    subBenefit2: "Swap, add, and generate dishes from your fridge",
    subBenefit3: "Smart insights and tips",
    subBenefit4: "'Surprise Me' feature",
    subBenefit5: "Ingredient priorities and exclusions",
    subBenefit6: "Three dish-generation focus modes",
    subBenefit7: "Auto-filled expiry dates",
    subTrialPrefix: "7 days free, then",
    subCtaSubscribe: "Subscribe",
    subTrialEndedTitle: "Your free trial has ended",
    subTrialEndedBody: "Subscribe to keep planning meals and seeing your weekly cost.",
    subAutoRenew: "Subscription renews automatically. Cancel anytime in one click.",
    subFirstChargeTrial: "First charge — {date}",
    subFirstChargeNow: "Charged immediately, then per your selected plan.",
    subTermsLink: "Subscription terms",
    "billing.success.checking": "Confirming your payment…",
    "billing.success.title": "Subscription activated 🎉",
    "billing.success.subtitle": "Thank you! All features are now unlocked.",
    "billing.success.cta": "Go to app",
    "billing.success.pending": "Payment received. Your status is updating — this can take up to a minute.",
    "billing.success.refresh": "Refresh",
    "billing.cancel.title": "Payment canceled",
    "billing.cancel.subtitle": "No subscription was created. You can go back and try again.",
    "billing.cancel.back": "Back to plans",
    "billing.cancel.home": "Home",
    "planDaysLeft_one":  "Remaining: {n} planning day",
    "planDaysLeft_few":  "Remaining: {n} planning days",
    "planDaysLeft_many": "Remaining: {n} planning days",
    "planDaysExhausted": "You've used all your planning days.",
    "planDaysInsufficient": "Not enough days for a {n}-day plan. Try a plan for fewer days.",
    "subManage": "Manage subscription",
    "subNextBilling": "Next payment:",
    "subTrialUntil": "Free trial until:",
    "subCanceledUntil": "Subscription canceled. Access until:",
    "subPortalError": "Couldn't open the portal. Please try again later.",
    subPlanYear: "Year",
    subPlanMonth: "Month",
    subPriceYear: "CA$89.99/yr",
    subPriceMonth: "CA$8.99/mo",
    subBestValue: "Best value",
    subSaveNote: "Save 2 months",
    subTrialShort: "7 days free",
    faq: "FAQ",
    privacy: "Privacy Policy",
    terms: "Terms & Conditions",
    termsAgreePrefix: "I accept the",
    termsLinkLabel: "Terms of Service",
    termsAgreeAnd: "and",
    privacyLinkLabel: "Privacy Policy",
    support: "Support",

    // Skip meal
    skipMealTitle: "Skip this meal",
    skipReason: "Comment (optional)",
    skipReasonPlaceholder: "e.g., ate something else...",
    confirmSkip: "Skip",
    ateElsewhere: "Ate elsewhere",
    notHungry: "Not hungry",

    // Servings / Guest scaling
    servingsFor: "for",
    persons: "persons",
    scaledIngredients: "Ingredients scaled",

    // Ingredient context
    inFridge: "In fridge",
    inCart: "Already in cart",
    missing: "Missing",
    addMissingToCart: "Add missing to cart",
    addedToCart: "Added to cart!",
    cart: "Cart",
    likedTips: "Liked tips",
    viewAll: "View all",
    
    // Add to Plan modal
    addToPlan: "Add to Plan",
    selectDate: "Which day?",
    selectMealType: "Which meal?",
    
    // Tips page
    allTips: "All",
    nutritionTips: "Nutrition",
    storageTips: "Storage",
    warningTips: "Warnings",
    noLikedTips: "No liked tips",
    noTipsAvailable: "No tips available",
    tipsAvailable: "tips",
    tipsForYou: "Tips for you",
    ingredientsTipHint: "Tap an ingredient to learn more",
    selectIngredientHint: "Select an ingredient to see details",
    noInfoAvailable: "Information unavailable",
    storageSection: "Storage tips",
    vitamins: "Vitamins",
    benefits: "Benefits",
    storageTip: "Storage",
    kcal: "kcal",

    // Dynamic servings scaling
    unsavedServingsChanges: "Click 'Save' to recalculate",
    servingsIncreased: "Guest count increased.",
    addDeficitToCart: "Add missing amounts to cart?",
    addToCart: "Add",
    needMore: "Need more",

    // Temporary exclusions
    temporaryExclusions: "Temporary Exclusions",
    temporaryExclusionsDesc: "AI won't suggest recipes with these ingredients",
    addExclusion: "Add Exclusion",
    exclusionIngredient: "Ingredient",
    excludeUntil: "Exclude until",
    oneWeek: "1 week",
    twoWeeks: "2 weeks",
    oneMonth: "1 month",
    noExclusions: "No active exclusions",
    priorityIngredients: "Priority Ingredients",
    priorityIngredientsDesc: "AI will try to include these in every day's meals (soft preference, up to 10)",
    addPriority: "Add Ingredient",
    priorityIngredient: "Search product…",
    noPriority: "No priority ingredients yet",
    priorityLimitReached: "Maximum 10 ingredients",

    // Focus mode
    focusMode: "Focus Mode",
    focusModeDesc: "How AI selects recipes",
    focusNoWaste: "No Waste",
    focusNoWasteDesc: "Prioritize fridge items near expiry",
    focusNewFlavors: "New Flavors",
    focusNewFlavorsDesc: "Prioritize new ingredients",
    focusBalance: "Balance",
    focusBalanceDesc: "Mix of both approaches",

    // Language selection
    selectLanguage: "Select Language",
    continueBtn: "Continue",
    languageCanChange: "You can change language in settings",

    // Onboarding favorite products - categories
    selectAllCategory: "Select all",
    deselectAll: "Deselect all",
    
    // Tutorial
    tutorialSkip: "Skip",
    tutorialNext: "Next",
    tutorialStep1: "Tap 'Generate' to create your first meal plan",
    tutorialStep2: "Great! Now tap on a dish to see the recipe",
    tutorialStep3: "Tap 'Add missing to cart' to add ingredients to your shopping list",
    tutorialStep4: "Now go to the cart to review your ingredients",
    tutorialStep5: "Check off all the products, then tap Purchased",
    tutorialStep6: "Great! Now go to the fridge to save your items",
    tutorialStep7: "Let's add expiry dates to your new items",
    tutorialStep8: "Items are safe! Tap Home to see what we're cooking today",
    tutorialStep9: "Let's cook this omelet! Tap on the dish",
    tutorialStep10: "We did it! Tap 'Done' to automatically remove used ingredients from your fridge",
    scrollDown: "Scroll down",
    goToShoppingList: "Go to shopping list",
    markAsDone: "Done",
    unsavedServingsWarning: "Serving changes are unsaved. Leave without saving?",

    // Onboarding favorite ingredients
    fav_turkey: "Turkey", fav_lamb: "Lamb", fav_bacon: "Bacon", fav_sausage: "Sausage",
    fav_tuna: "Tuna", fav_cod: "Cod", fav_mussels: "Mussels",
    fav_butter: "Butter", fav_cream: "Cream", fav_cottage_cheese: "Cottage Cheese",
    fav_onion: "Onion", fav_garlic: "Garlic", fav_carrot: "Carrot", fav_pepper: "Pepper",
    fav_cucumber: "Cucumber", fav_zucchini: "Zucchini", fav_cabbage: "Cabbage", fav_eggplant: "Eggplant",
    fav_apple: "Apple", fav_orange: "Orange", fav_lemon: "Lemon", fav_berries: "Berries", fav_grapes: "Grapes",
    fav_buckwheat: "Buckwheat", fav_quinoa: "Quinoa", fav_flour: "Flour",
    fav_chickpeas: "Chickpeas", fav_peas: "Peas",
    fav_lavash: "Lavash", fav_bun: "Buns", fav_pastry: "Pastry", fav_gluten_free_bread: "Gluten-Free Bread", fav_crackers: "Crackers", fav_pita: "Pita",
    cat_meat: "Meat", cat_seafood: "Seafood", cat_dairy: "Dairy", cat_vegetables: "Vegetables",
    cat_fruits: "Fruits", cat_grains: "Grains", cat_legumes: "Legumes", cat_bakery: "Bakery",
    noInsightsYet: "No insights yet",
    noInsightsDesc: "Cook more dishes — AI analyzes your diet and will provide personalized tips",

    mealScoreTitle: "How was the dish?",
    mealScoreSub: "Your rating helps AI recommend better",

    // Admin panel
    adminAccessTitle: "Admin access",
    adminAccessSub: "Enter admin password",
    adminPassword: "Password",
    adminVerifying: "Verifying...",
    adminEnter: "Enter",
    adminWrongPassword: "Wrong password",
    adminLogout: "Logout",
    adminDashboard: "Dashboard",
    adminUsers: "Users",
    adminUnknownProducts: "Unknown products",
    adminSupport: "Support",
    adminStats: "General statistics",
    adminAllRecognized: "All products recognized",
    adminNoMessages: "No messages",
    adminNew: "New",
    adminAll: "All",
    adminRead: "Read",
    adminLoadError: "Loading error",
    generateFromFridge: "From available ingredients",
    fromFridge: "From fridge",
  },
  ru: {
    // Analytics consent
    consentTitle: "Персонализированные рекомендации",
    consentBody: "Чтобы подбирать блюда точнее, MealPill запоминает ваши действия в приложении — какие рецепты вы сохраняете, что готовите, что добавляете в холодильник. Из этого формируется ваш вкусовой профиль.",
    consentNote: "Эти данные хранятся у нас и не передаются рекламодателям.",
    consentToggle: "Персонализировать рекомендации",
    consentHint: "Можно изменить в любое время в Настройках",
    consentContinue: "Продолжить",
    privacyTitle: "Приватность",
    privacyAnalyticsDesc: "Использовать ваши действия в приложении для персонализации рекомендаций",
    tipType_storage: "Хранение",
    tipType_nutrition: "Питание",
    tipType_warning: "Внимание",
    tipType_reminder: "Напоминание",
    tipType_default: "Совет",
    editRecipe: "Редактировать рецепт",
    loadMore: "Загрузить ещё",
    // Auth
    login: "Войти",
    register: "Регистрация",
    email: "Электронная почта",
    password: "Пароль",
    forgotPassword: "Забыли пароль?",
    resetYourPassword: "Восстановление пароля",
forgotPasswordDesc: "Введи свой email и мы отправим ссылку для восстановления пароля.",
sendResetLink: "Отправить ссылку",
backToSignIn: "Назад ко входу",
checkYourEmail: "Проверь почту",
resetLinkSent: "Если аккаунт существует — мы отправили ссылку для восстановления.",
checkSpam: "Не получил? Проверь папку Спам.",
    name: "Имя",
    noAccount: "Нет аккаунта?",
    hasAccount: "Уже есть аккаунт?",
    emailAlreadyRegistered: "Этот email уже зарегистрирован. Похоже, у тебя уже есть аккаунт.",
    goToLogin: "Войти с этим email",
    genFailed: "Не удалось сгенерировать план. Сервис ИИ перегружен — попробуй через минуту.",
    recipeSaveFailed: "Не удалось сохранить рецепт. Проверьте соединение и попробуйте ещё раз.",
    errInvalidCredentials: "Неверный email или пароль.",
    errPasswordMinLength: "Пароль должен содержать не менее 8 символов.",
    errPasswordLetter: "Пароль должен содержать хотя бы одну букву.",
    errPasswordDigit: "Пароль должен содержать хотя бы одну цифру или специальный символ.",
    errPasswordCommon: "Этот пароль слишком распространён. Выберите более надёжный.",
    errResetLinkInvalid: "Ссылка для сброса пароля недействительна или устарела.",
    errResetLinkExpired: "Срок действия ссылки истёк. Запросите новую.",
    tipsEmptyState: "Советов пока нет — сгенерируйте несколько планов, и они появятся здесь.",
    errPasswordsDontMatch: "Пароли не совпадают.",
    errNetwork: "Ошибка сети. Попробуйте ещё раз.",
    errRateLimit: "Слишком много попыток. Попробуй позже",
    errGeneric: "Что-то пошло не так",
    resetInvalidTitle: "Недействительная ссылка",
    resetInvalidBody: "Ссылка отсутствует или повреждена. Запросите новый сброс пароля.",
    resetRequestNew: "Запросить новую ссылку",
    resetSetNewTitle: "Установите новый пароль",
    resetSetNewDesc: "Выберите надёжный пароль, который вы ещё не использовали.",
    resetNewPasswordPh: "Новый пароль (мин. 8 символов)",
    resetConfirmPh: "Подтвердите новый пароль",
    resetSubmit: "Сбросить пароль",
    resetDoneTitle: "Пароль изменён",
    resetDoneBody: "Ваш пароль обновлён.",
    resetRedirecting: "Перенаправляем на вход...",
    resetGoToSignIn: "Перейти ко входу",
    createAccount: "Создать аккаунт",
    welcome: "Добро пожаловать",
    welcomeBack: "С возвращением",
    authBackHome: "Назад в MealPill",
    logout: "Выйти",

    // Intro Carousel
    introSlide1Title: "Умная Аналитика",
    introSlide1Desc: "Отслеживайте калории, разнообразие рациона и получайте персонализированные рекомендации на основе ваших привычек.",
    introSlide2Title: "Режимы Приоритета",
    introSlide2Desc: "Выбирайте между 'Без отходов' для использования продуктов с истекающим сроком или 'Новые вкусы' для кулинарных экспериментов.",
    introSlide3Title: "Ежедневные Советы",
    introSlide3Desc: "Получайте полезные подсказки по питанию, приготовлению и экономии на продуктах каждый день.",
    introSlide4Title: "Система Избранного",
    introSlide4Desc: "Сохраняйте любимые рецепты и советы. AI будет учитывать ваши предпочтения для лучших рекомендаций.",
    getStarted: "Начать",

    // Onboarding
    onboardingTitle: "Давайте настроим Meal Pill для вас",
    step: "Шаг",
    of: "из",
    next: "Далее",
    back: "Назад",
    finish: "Завершить",
    skip: "Пропустить",

    // Step 0 - Language
    languageTitle: "Выберите язык",
    languageSubtitle: "Вы можете изменить его позже в настройках",
    langUk: "Українська",
    langEn: "English",
    langRu: "Русский",

    // Step 1 - Goals
    goalTitle: "Почему вы хотите использовать это приложение?",
    goalSubtitle: "Выберите все подходящие",
    goal_organized: "Чтобы быть лучше организованным",
    goal_diet: "Чтобы помочь мне с диетой",
    goal_lose_weight: "Чтобы помочь мне похудеть",
    goal_gain_weight: "Чтобы помочь мне набрать вес",
    goal_save_money: "Чтобы сэкономить на продуктах",
    goal_track_habits: "Чтобы следить за пищевыми привычками",
    goal_save_time: "Чтобы сэкономить время",
    goal_recipe_ideas: "Для идей рецептов",
    goal_health: "Чтобы улучшить здоровье",
    goal_family: "Планировать для большой семьи",
    goal_muscle: "Увеличить мышечную массу",
    goal_pregnancy: "Из-за беременности",
    goal_other: "Другое",

    // Step 2 - Diet type
    dietTitle: "Какой у вас образ жизни?",
    diet_omnivore: "Всеядный",
    diet_pesco_pollo: "Песко-полло",
    diet_pesco_pollo_desc: "Рыба и птица, без красного мяса",
    diet_pescatarian: "Пескетарианец",
    diet_pescatarian_desc: "Рыба, без мяса",
    diet_vegetarian: "Вегетарианский",
    diet_vegan: "Веганский",

    // Step 3 - Meals & People
    mealsTitle: "Какие приемы пищи вы хотите планировать?",
    mealsSubtitle: "Выберите все подходящие",
    breakfast: "Завтрак",
    lunch: "Обед",
    dinner: "Ужин",
    snack: "Перекус",
    familyTitle: "На сколько человек вы готовите?",
    person: "человек",
    people: "человек",
    moreThan5: "Больше 5",

    // Step 4 - Budget & Calendar
    budgetTitle: "Сколько вы тратите на продукты в месяц?",
    budgetHint: "Планирование может сэкономить до 30% на продуктах",
    budgetPlaceholder: "Например, 5000",
    firstDayOfWeek: "Первый день недели",
    monday: "Понедельник",
    tuesday: "Вторник",
    wednesday: "Среда",
    thursday: "Четверг",
    friday: "Пятница",
    saturday: "Суббота",
    sunday: "Воскресенье",

    // Step 5 - Preferences & Skill
    preferencesTitle: "Диетические ограничения",
    vegetarian: "Вегетарианство",
    vegan: "Веганство",
    glutenFree: "Без глютена",
    lactoseFree: "Без лактозы",
    nutFree: "Без орехов",
    halal: "Халяль",
    cookingSkill: "Уровень кулинарии",
    beginner: "Начинающий",
    intermediate: "Средний",
    advanced: "Опытный",
    cookingTime: "Время на готовку",
    quick: "Быстро (до 20 мин)",
    medium: "Средне (20-45 мин)",
    long: "Долго (45+ мин)",

    // Step 6 - Favorite Ingredients (expanded)
    favIngredientsTitle: "Ваши любимые продукты",
    favIngredientsSubtitle: "Выберите то, что вы часто едите",
    fav_chicken: "Курица",
    fav_beef: "Говядина",
    fav_pork: "Свинина",
    fav_fish: "Рыба",
    fav_eggs: "Яйца",
    fav_rice: "Рис",
    fav_pasta: "Паста",
    fav_potato: "Картофель",
    fav_tomato: "Помидоры",
    fav_cheese: "Сыр",
    fav_milk: "Молоко",
    fav_bread: "Хлеб",
    fav_avocado: "Авокадо",
    fav_salmon: "Лосось",
    fav_shrimp: "Креветки",
    fav_tofu: "Тофу",
    fav_mushrooms: "Грибы",
    fav_broccoli: "Брокколи",
    fav_spinach: "Шпинат",
    fav_beans: "Фасоль",
    fav_lentils: "Чечевица",
    fav_oats: "Овсянка",
    fav_yogurt: "Йогурт",
    fav_banana: "Банан",
    fav_cucumber: "Огурцы",
    fav_onion: "Лук",
    fav_garlic: "Чеснок",
    fav_pepper: "Перец",
    fav_carrot: "Морковь",
    fav_cabbage: "Капуста",
    fav_apple: "Яблоки",
    fav_lemon: "Лимон",
    fav_honey: "Мед",
    fav_nuts: "Орехи",
    fav_buckwheat: "Гречка",
    fav_turkey: "Индейка",

    // Step 7 - Favorite Cuisines
    cuisinesTitle: "Любимые кухни",
    cuisinesSubtitle: "Какие кухни мира вам нравятся?",
    cuisine_ukrainian: "Украинская",
    cuisine_italian: "Итальянская",
    cuisine_asian: "Азиатская",
    cuisine_mexican: "Мексиканская",
    cuisine_mediterranean: "Средиземноморская",
    cuisine_french: "Французская",
    cuisine_american: "Американская",
    cuisine_indian: "Индийская",
    cuisine_japanese: "Японская",
    cuisine_chinese: "Китайская",
    cuisine_georgian: "Грузинская",
    cuisine_turkish: "Турецкая",

    // Home
    greeting: "Привет",
    todaysMeals: "Сегодняшнее меню",
    todaysMenu: "Меню на сегодня",
    todaysMenuCollapsedHint: "Меню на сегодня свёрнуто — нажмите, чтобы развернуть",
    noPlanForToday: "На сегодня пока ничего не запланировано",
    planForDay: "Спланировать",
    dailyTips: "Советы дня",
    quickActions: "Быстрые действия",
    planMeals: "Планировать",
    myFridge: "Мой холодильник",
    shoppingList: "Список покупок",
    surpriseMe: "Удиви меня!",
    open: "Открыть",
    replace: "Заменить",
    skipMeal: "Пропустить",
    skipped: "Пропущено",
    noMealsYet: "Меню еще не сгенерировано",
    generatePlan: "Создать план",
    loading: "Загрузка...",
    generating: "Генерация...",
    cookTimeShort: "мин",
    removeDish: "Удалить",
    removed: "удалено",
    undo: "Вернуть",
    addDish: "Добавить блюдо",
    addDishSelectType: "Выберите тип блюда",
    addDishChooseMode: "Как добавить?",
    addDishCustom: "Добавить своё блюдо",
    generateDish: "Сгенерировать",
    generateDishDesc: "AI создаст блюдо по вашим предпочтениям",
    addCustomDish: "Добавить своё",
    addCustomDishDesc: "Введите название и описание блюда",
    dishTitlePlaceholder: "Название блюда",
    dishDescPlaceholder: "Краткое описание (необязательно)",
    main_course: "Основное блюдо",
    side_dish: "Гарнир",
    salad: "Салат",
    appetizer: "Закуска",
    likeTip: "Нравится",
    unlikeTip: "Не нравится",

    // Dynamic greetings (50)
    dynGreeting_0: "Чудесного кулинарного дня, {name}!",
    dynGreeting_1: "Морковный пирог скучает по тебе, {name}",
    dynGreeting_2: "Смузи сегодня в хорошем настроении!",
    dynGreeting_3: "Время готовить что-то невероятное, {name}!",
    dynGreeting_4: "Сегодня идеальный день для новых вкусов!",
    dynGreeting_5: "Кто-то сказал «пицца»? Привет, {name}!",
    dynGreeting_6: "Твой холодильник ждет приключений!",
    dynGreeting_7: "Запах свежей выпечки уже в воздухе, {name}",
    dynGreeting_8: "Даже макароны рады тебя видеть!",
    dynGreeting_9: "Сегодня готовим с вдохновением!",
    dynGreeting_10: "Авокадо передает привет, {name}!",
    dynGreeting_11: "Специи уже выстраиваются в очередь!",
    dynGreeting_12: "Какое сегодня настроение? Сладкое или острое?",
    dynGreeting_13: "Борщ снова спрашивает о тебе, {name}",
    dynGreeting_14: "Твоя кухня — твоя суперсила!",
    dynGreeting_15: "Время превратить продукты в шедевр!",
    dynGreeting_16: "Завтрак — это всегда хорошая идея!",
    dynGreeting_17: "Хороший день начинается с вкусной еды!",
    dynGreeting_18: "Картошка уже разогрелась для тебя!",
    dynGreeting_19: "Готовь с любовью, {name}!",
    dynGreeting_20: "Сегодня ты шеф-повар!",
    dynGreeting_21: "Даже соль счастлива тебя видеть!",
    dynGreeting_22: "Пора создать кулинарный шедевр!",
    dynGreeting_23: "Кухня ждет свою звезду, {name}!",
    dynGreeting_24: "Давай удивим вкусовые рецепторы!",
    dynGreeting_25: "Тарелка уже мечтает о чем-то вкусном!",
    dynGreeting_26: "Сегодняшний день пахнет корицей!",
    dynGreeting_27: "Время открыть новые кулинарные горизонты!",
    dynGreeting_28: "Помидоры ждут своего звездного часа!",
    dynGreeting_29: "Хорошее настроение + хорошая еда = идеальный день!",
    dynGreeting_30: "Сегодня готовим с душой, {name}!",
    dynGreeting_31: "Сковорода уже разогрета, шеф!",
    dynGreeting_32: "Овощи устраивают вечеринку на твоей тарелке!",
    dynGreeting_33: "Рис передает теплый привет!",
    dynGreeting_34: "Время добавить немного магии на кухне!",
    dynGreeting_35: "Духовка уже предчувствует что-то вкусное!",
    dynGreeting_36: "Яйца готовы к любым приключениям!",
    dynGreeting_37: "Бон аппетит начинается здесь, {name}!",
    dynGreeting_38: "Сегодня на кухне будет весело!",
    dynGreeting_39: "Чеснок говорит: давай готовить!",
    dynGreeting_40: "Кулинарное путешествие начинается, {name}!",
    dynGreeting_41: "Твой обед будет непревзойденным!",
    dynGreeting_42: "Масло уже трещит от нетерпения!",
    dynGreeting_43: "Йогурт хочет стать частью твоего дня!",
    dynGreeting_44: "Мед и овсянка шлют тебе улыбку!",
    dynGreeting_45: "Сыр уже расплавился от радости!",
    dynGreeting_46: "Зелень ждет своего выхода, {name}!",
    dynGreeting_47: "Ничто не сравнится с домашней едой!",
    dynGreeting_48: "Кастрюля полна идей для тебя!",
    dynGreeting_49: "Привет, гурман! Что готовим сегодня?",

    // Fridge
    fridgeTitle: "Мой холодильник",
    pantryTitle: "Кладовая",
    addItem: "Добавить продукт",
    addFridgeItem: "Добавить продукт",
    itemName: "Название продукта",
    category: "Категория",
    quantity: "Количество",
    unit: "Единица",
    expiryDate: "Срок годности",
    meat: "Мясо",
    fish: "Рыба",
    dairy: "Молочные",
    vegetables: "Овощи",
    fruits: "Фрукты",
    frozen: "Замороженные",
    dryGoods: "Крупы",
    spices: "Специи",
    beverages: "Напитки",
    other: "Другое",
    emptyFridge: "Холодильник пуст",
    addFirst: "Добавьте первые продукты",
    fridgeSelect: "Выбрать",
    fridgeClear: "Очистить",
    fridgeSelectAll: "Выбрать все",
    fridgeDeselectAll: "Снять все",
    fridgeSelectedCount: "Выбрано: {n}",
    fridgeDeleteSelected: "Удалить выбранные ({n})",
    fridgeClearTitle: "Очистить холодильник?",
    fridgeClearMsg: "Все продукты ({n}) будут удалены. Вернуть их будет невозможно.",
    fridgeClearConfirm: "Да, очистить",
    save: "Сохранить",
    cancel: "Отмена",
    delete: "Удалить",
    qs_title: "Что есть дома?",
    qs_subtitle: "Отметьте продукты, которые у вас есть. Остальное добавите позже.",
    qs_skip: "Пока пусто",
    qs_generate: "Добавить в холодильник",
    deleteRecipeTitle: "Удалить рецепт?",
    actionCannotUndo: "Это действие нельзя отменить",
    nameField: "Название",
    recipeNamePlaceholder: "Например: Паста карбонара",
    description: "Описание",
    optional: "Необязательно",
    mealType: "Тип приёма",
    notSpecified: "Не указывать",
    cookTimeMinLabel: "Время (мин)",
    addIngredient: "Добавить ингредиент",
    cookingSteps: "Шаги приготовления",
    describeStep: "Опишите шаг",
    addStepPhoto: "Добавить фото к шагу",
    addStep: "Добавить шаг",
    recipeVideo: "Видео рецепта",
    videoUrlPlaceholder: "Ссылка на YouTube или другое видео",
    expiresIn: "Истекает через",
    days: "дн.",
    expired: "Просрочено",
    daysLeft: "дн.",
    today: "Сегодня",
    fridgeItemCount: "продуктов",
    fridgeItemCount_one: "продукт",
    fridgeItemCount_few: "продукта",
    noExpiringItems: "Нет продуктов с истекающим сроком",
    showAll: "Показать все",
    showingExpiring: "Показаны продукты со сроком < 4 дней",
    expiryAlertTitle: "Внимание! Срок годности некоторых продуктов истекает менее чем через 4 дня.",
    expiryAlertMsg: "Просмотреть список",
    expiredNotUsed: "Некоторые продукты уже просрочены — они не попадают в план",
    newProducts: "Новые продукты",
    newProductsMsg: "{n} продуктов ожидают распределения",
    newProductsMsg_one: "{n} продукт ожидает распределения",
    newProductsMsg_few: "{n} продукта ожидают распределения",
    offCatalogPurgedHint: "{n} продуктов ещё нет в базе — добавим",
    offCatalogPurgedHint_one: "{n} продукт ещё нет в базе — добавим",
    offCatalogPurgedHint_few: "{n} продукта ещё нет в базе",
    setPendingExpiry: "Укажите срок годности для каждого продукта",
    addToFridge: "Добавить в холодильник",
    autoExpiryPremium: "Сроки заполнены автоматически на основе базы продуктов",
    purchased: "Куплено",
    smartCheck: "Умная проверка",

    // Meal Planner
    mealPlannerTitle: "Планировщик меню",
    thisWeek: "Эта неделя",
    generateForDay: "На день",
    generateFor3Days: "На 3 дня",
    generateForWeek: "На неделю",
    cal: "ккал",
    min: "мин",
    cookTimeLabel: "Время готовки",
    cookTimeNoLimit: "Без ограничений",

    // Recipe
    recipeDetails: "Детали рецепта",
    ingredients: "Ингредиенты",
    instructions: "Инструкция",
    prepTime: "Подготовка",
    cookTime: "Готовка",
    servings: "Порций",
    nutrition: "Пищевая ценность",
    protein: "Белки",
    carbs: "Углеводы",
    fat: "Жиры",
    nutritionPartial: "рассчитано по {resolved} из {total} ингредиентов",
    calories: "Калории",
    addToFavorites: "Добавить в избранное",
    removeFromFavorites: "Удалить из избранного",

    // Grocery
    groceryTitle: "Список покупок",
    generateList: "Сгенерировать список",
    emptyList: "Список пуст",
    itemsChecked: "отмечено",
    groceryStaleTitle: "Меню было изменено",
    groceryStaleMsg: "Обновите список покупок для актуальных ингредиентов",
    refresh: "Обновить",
    translating: "Переводим...",
    syncBannerTitle: "Изменения в рецептах или количестве гостей!",
    syncBannerMsg: "Обновите список покупок для актуализации данных",
    updateList: "Обновить",
    generate1Day: "Сгенерировать на 1 день",
    generate3Day: "Сгенерировать на 3 дня",
    generate7Day: "Сгенерировать на 1 неделю",
    gen1Short: "1 день",
    gen3Short: "3 дня",
    gen7Short: "Неделя",
    regenerateFor: "Перегенерировать для",
    addItemTitle: "Добавить продукт",
    newIngredientThanks: "новый ингредиент, спасибо",
    addToCart: "Добавить в покупки",
    stagingEmpty: "Начни вводить продукт…",
    searchOrType: "Поиск или введите название",
    allCategories: "Все категории",
    noSuggestions: "Начните вводить название",
    manualTag: "добавлено вручную",
    amountPlaceholder: "Количество",
    qtyDefaultHint: "Проверь количество и исправь при необходимости",
    cat_dairy: "Молочные",
    cat_meat: "Мясо",
    cat_seafood: "Морепродукты",
    cat_vegetables: "Овощи",
    cat_fruits: "Фрукты",
    cat_grains: "Крупы и злаки",
    cat_legumes: "Бобовые",
    cat_spices: "Специи",
    cat_bakery: "Выпечка",
    cat_beverages: "Напитки",
    cat_other: "Другое",

    // Favorites / My Dishes - REFACTORED
    favoritesTitle: "Избранное",
    myDishesTitle: "Мои блюда",
    favorites: "Избранное",
    createRecipe: "Создать рецепт",
    saveRecipe: "Сохранить рецепт",
    favoriteRecipes: "Избранные рецепты",
    myRecipes: "Мои рецепты",
    favoriteTips: "Избранные советы",
    noDishes: "Пока нет блюд",
    noFavoriteRecipes: "Нет избранных рецептов",
    noMyRecipes: "Нет собственных рецептов",
    noFavoriteTips: "Нет избранных советов",
    addRecipe: "Добавить рецепт",

    // Insights
    insightsTitle: "Умная аналитика",
    weeklySummary: "Недельная сводка",
    avgCalories: "Ср. калории",
    topIngredients: "Топ ингредиенты",
    varietyScore: "Разнообразие",
    wasteRisk: "Риск порчи",
    refreshInsights: "Обновить аналитику",

    // Settings
    settingsTitle: "Настройки",
    profile: "Профиль",
    language: "Язык",
    preferences: "Предпочтения",
    guestMode: "Гостевой режим",
    guestModeDesc: "Временно увеличить порции для гостей",
    guests: "гостей",
    dateFrom: "Дата от",
    dateTo: "Дата до",
    mealsForGuests: "Приемы пищи для гостей",
    appVersion: "Версия приложения",
    editPreferences: "Изменить предпочтения",
    redoOnboarding: "Пройти настройку заново",

    // Nav
    home: "Главная",
    fridge: "Холодильник",
    planner: "Планер",
    grocery: "Покупки",
    dishes: "Блюда",
    settings: "Настройки",

    // Side menu
    familyAccess: "Семейный доступ",
    smartInsights: "Умная аналитика",
    nutritionMode: "Нутрициология",
    subscription: "Подписка",
    subTitle: "Подписка Meal Pill",
    subSubtitle: "Переведи планирование еды в расслабленный режим",
    subPrice: "CA$8.99/мес",
    subTrialNote: "7 дней бесплатно, затем CA$8.99/мес",
    subCta: "Попробовать 7 дней бесплатно",
    subLoading: "Подождите...",
    subActiveMsg: "Ваша подписка активна",
    subFinePrint: "Отменить можно в любой момент. Напомним перед списанием.",
    subBenefit1: "AI-планы питания на каждый день",
    subBenefit2: "Замена, добавление и генерация блюд из холодильника",
    subBenefit3: "Умные инсайты и советы",
    subBenefit4: "Функция «Удиви меня»",
    subBenefit5: "Приоритеты и исключения продуктов",
    subBenefit6: "Три режима фокуса генерации блюд",
    subBenefit7: "Автозаполнение сроков годности",
    subTrialPrefix: "7 дней бесплатно, затем",
    subCtaSubscribe: "Оформить подписку",
    subTrialEndedTitle: "Пробный период завершён",
    subTrialEndedBody: "Продлите, чтобы и дальше планировать меню и видеть стоимость недели.",
    subAutoRenew: "Подписка продлевается автоматически. Отменить можно в любой момент одним кликом.",
    subFirstChargeTrial: "Первое списание — {date}",
    subFirstChargeNow: "Списание сразу после оформления, далее — по выбранному плану.",
    subTermsLink: "Условия подписки",
    "billing.success.checking": "Подтверждаем оплату…",
    "billing.success.title": "Подписка активирована 🎉",
    "billing.success.subtitle": "Спасибо! Теперь все функции открыты.",
    "billing.success.cta": "В приложение",
    "billing.success.pending": "Оплата получена. Статус обновляется — это может занять до минуты.",
    "billing.success.refresh": "Обновить",
    "billing.cancel.title": "Оплата отменена",
    "billing.cancel.subtitle": "Подписка не оформлена. Можешь вернуться и попробовать снова.",
    "billing.cancel.back": "Вернуться к планам",
    "billing.cancel.home": "На главную",
    "planDaysLeft_one":  "Осталось: {n} день планирования",
    "planDaysLeft_few":  "Осталось: {n} дня планирования",
    "planDaysLeft_many": "Осталось: {n} дней планирования",
    "planDaysExhausted": "Вы использовали все дни для планирования.",
    "planDaysInsufficient": "Недостаточно дней для {n}-дневного плана. Попробуй план на меньшее количество дней.",
    "subManage": "Управление подпиской",
    "subNextBilling": "Следующее списание:",
    "subTrialUntil": "Пробный период до:",
    "subCanceledUntil": "Подписка отменена. Доступ до:",
    "subPortalError": "Не удалось открыть управление. Попробуйте позже.",
    subPlanYear: "Год",
    subPlanMonth: "Месяц",
    subPriceYear: "CA$89.99/год",
    subPriceMonth: "CA$8.99/мес",
    subBestValue: "Выгоднее всего",
    subSaveNote: "Экономия 2 месяца",
    subTrialShort: "7 дней бесплатно",
    faq: "FAQ",
    privacy: "Конфиденциальность",
    terms: "Условия использования",
    termsAgreePrefix: "Я принимаю",
    termsLinkLabel: "Условия использования",
    termsAgreeAnd: "и",
    privacyLinkLabel: "Политику конфиденциальности",
    support: "Поддержка",

    // Skip meal
    skipMealTitle: "Пропустить прием пищи",
    skipReason: "Комментарий (необязательно)",
    skipReasonPlaceholder: "Например: ел что-то другое...",
    confirmSkip: "Пропустить",
    ateElsewhere: "Ел другое",
    notHungry: "Не голоден",

    // Servings / Guest scaling
    servingsFor: "на",
    persons: "человек",
    scaledIngredients: "Ингредиенты масштабированы",

    // Ingredient context
    inFridge: "Есть в холодильнике",
    inCart: "Уже в плане покупок",
    missing: "Нет",
    addMissingToCart: "Добавить отсутствующие в корзину",

    // Temporary exclusions
    temporaryExclusions: "Временные исключения",
    temporaryExclusionsDesc: "AI не будет предлагать рецепты с этими ингредиентами",
    addExclusion: "Добавить исключение",
    exclusionIngredient: "Ингредиент",
    excludeUntil: "Исключить до",
    oneWeek: "1 неделя",
    twoWeeks: "2 недели",
    oneMonth: "1 месяц",
    noExclusions: "Нет активных исключений",
    priorityIngredients: "Приоритетные продукты",
    priorityIngredientsDesc: "AI будет стараться включать эти продукты каждый день (мягкий приоритет, до 10)",
    addPriority: "Добавить продукт",
    priorityIngredient: "Поиск продукта…",
    noPriority: "Пока нет приоритетных продуктов",
    priorityLimitReached: "Максимум 10 продуктов",

    // Focus mode
    focusMode: "Режим фокуса",
    focusModeDesc: "Как AI выбирает рецепты",
    focusNoWaste: "Без отходов",
    focusNoWasteDesc: "Приоритет продуктам из холодильника, которые скоро испортятся",
    focusNewFlavors: "Новые вкусы",
    focusNewFlavorsDesc: "Приоритет новым ингредиентам",
    focusBalance: "Баланс",
    focusBalanceDesc: "Микс обоих подходов",
    comingSoon: "Скоро",
    selectDishForPlan: "Выберите блюдо для плана",
    cooked: "Приготовлено ✓",
    noMealPlanned: "Блюдо еще не запланировано",
    addFromFavoritesDesc: "Выбрать из избранных рецептов",
    addFromMyRecipesDesc: "Выбрать из ваших рецептов",
    aiGeneration: "AI генерация",
    aiGenerationDesc: "AI создаст блюдо по вашим предпочтениям",
    emptyListTitle: "Ваш список пуст",
    emptyListMessage: "Добавьте продукты вручную или сгенерируйте список из вашего плана питания",
    addItemManually: "Добавить продукт",
    generateFromPlan: "Сгенерировать из плана",
    goToPlanner: "Перейти к планировщику",
    or: "или",
    clearAll: "Очистить",
    clearListTitle: "Очистить список?",
    clearListMessage: "Все продукты будут удалены из корзины. Это действие нельзя отменить.",
    manualItemsSection: "Добавлено вручную",
    cat_eggs: "Яйца",
    cat_dairy_eggs: "Молочные продукты",
    cat_deli_meat: "Колбасы",
    cat_mushrooms: "Грибы",
    cat_fruits_berries: "Фрукты и ягоды",
    cat_grains_bakery: "Крупы и хлеб",
    cat_nuts_seeds: "Орехи и семена",
    cat_spices_oils: "Специи и масла",
    cat_sweets_snacks: "Сладости",
    cat_frozen_foods: "Заморозка",
    cat_beverages_alcohol: "Алкоголь",
    addedToCart: "Добавлено в корзину!",
    cart: "Корзина",
    likedTips: "Понравившиеся советы",
    viewAll: "Смотреть все",
    addToPlan: "Добавить в план",
    selectDate: "На какой день?",
    selectMealType: "Какой прием пищи?",
    allTips: "Все",
    nutritionTips: "Питание",
    storageTips: "Хранение",
    warningTips: "Предупреждения",
    noLikedTips: "Нет понравившихся советов",
    noTipsAvailable: "Нет советов",
    tipsAvailable: "советов",
    tipsForYou: "Советы для вас",
    ingredientsTipHint: "Нажми на ингредиент чтобы узнать больше",
    selectIngredientHint: "Выбери ингредиент чтобы увидеть детали",
    noInfoAvailable: "Информация недоступна",
    storageSection: "Советы по хранению",
    vitamins: "Витамины",
    benefits: "Польза",
    storageTip: "Хранение",
    kcal: "ккал",
    unsavedServingsChanges: "Нажмите 'Сохранить' для пересчета",
    servingsIncreased: "Количество гостей увеличено.",
    addDeficitToCart: "Добавить разницу в план покупок?",
    addToCart: "Добавить",
    needMore: "Нужно еще",
    selectLanguage: "Выберите язык",
    continueBtn: "Продолжить",
    languageCanChange: "Вы сможете изменить язык в настройках",
    selectAllCategory: "Выбрать все",
    deselectAll: "Снять выбор",
    tutorialSkip: "Пропустить",
    tutorialNext: "Далее",
    tutorialStep1: "Нажми 'Генерировать', чтобы создать свой первый план питания",
    tutorialStep2: "Отлично! Теперь нажми на блюдо, чтобы увидеть рецепт",
    tutorialStep3: "Нажми 'Добавить отсутствующие в корзину', чтобы добавить ингредиенты в список покупок",
    tutorialStep4: "Теперь перейди в корзину, чтобы просмотреть ингредиенты",
    tutorialStep5: "Отметь все продукты, затем нажми «Куплено»",
    tutorialStep6: "Отлично! Теперь перейди в холодильник, чтобы сохранить продукты",
    tutorialStep7: "Давай добавим сроки годности к новым продуктам",
    tutorialStep8: "Продукты в безопасности! Нажми на главную, чтобы посмотреть что готовим сегодня",
    tutorialStep9: "Давай приготовим этот омлет! Нажми на блюдо",
    tutorialStep10: "Мы справились! Нажми 'Готово', чтобы я автоматически убрал использованные продукты из холодильника",
    scrollDown: "Прокрути вниз",
    goToShoppingList: "Перейти в план покупок",
    markAsDone: "Готово",
    unsavedServingsWarning: "Изменения порций не сохранены. Уйти без сохранения?",
    fav_tuna: "Тунец", fav_cod: "Треска", fav_mussels: "Мидии",
    fav_lamb: "Баранина", fav_bacon: "Бекон", fav_sausage: "Колбаса", fav_zucchini: "Кабачок", fav_eggplant: "Баклажан", fav_orange: "Апельсин", fav_berries: "Ягоды", fav_grapes: "Виноград", fav_quinoa: "Киноа", fav_flour: "Мука",
    fav_butter: "Масло", fav_cream: "Сливки", fav_cottage_cheese: "Творог",
    fav_chickpeas: "Нут", fav_peas: "Горох",
    fav_lavash: "Лаваш", fav_bun: "Булочки", fav_pastry: "Выпечка", fav_gluten_free_bread: "Безглютеновый хлеб", fav_crackers: "Крекеры", fav_pita: "Пита",
    noInsightsYet: "Пока нет инсайтов",
    noInsightsDesc: "Готовьте больше блюд — AI анализирует ваш рацион и предоставит персональные советы",
    mealScoreTitle: "Как вам блюдо?",
    mealScoreSub: "Ваша оценка помогает AI рекомендовать лучше",
    adminAccessTitle: "Admin доступ",
    adminAccessSub: "Введите пароль админа",
    adminPassword: "Пароль",
    adminVerifying: "Проверка...",
    adminEnter: "Войти",
    adminWrongPassword: "Неверный пароль",
    adminLogout: "Выйти",
    adminDashboard: "Дашборд",
    adminUsers: "Пользователи",
    adminUnknownProducts: "Неизвестные продукты",
    adminSupport: "Поддержка",
    adminStats: "Общая статистика",
    adminAllRecognized: "Все продукты распознаны",
    adminNoMessages: "Сообщений нет",
    adminNew: "Новые",
    adminAll: "Все",
    adminRead: "Прочитанные",
    adminLoadError: "Ошибка загрузки",
    generateFromFridge: "Из имеющихся ингредиентов",
    fromFridge: "Из холодильника",
  },
};

export default translations;
